import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { ChartType } from '@/features/_shared/chart/types/highcharts';

export type ChartButtonRenderer = (graphType: ChartType) => ReactNode;

export const ExportChartButtonContext = createContext<ChartButtonRenderer | null>(null);

export const useExportChartButton = () => useContext(ExportChartButtonContext);
